export default {
  name: "error-page",
  components: {},
  props: [],
  data() {
    return {
      logoImage: require("@/assets/image/NotFoundPage/Logo.svg")
    };
  },
  computed: {},
  mounted() {},
  methods: {}
};
